import ApiService from './api.service'
import { TokenService } from './storage.service'
import AccountInventoryService from './accountinventory.service'
import store from '@/store'
import { parseToken, getUserGroup } from '@/utils/helper'
// import Roles from '@/utils/role'
import Vue from 'vue'

class AuthenticationError extends Error {
  constructor (errorCode, message) {
    super(message)
    this.name = this.constructor.name
    this.message = message
    this.errorCode = errorCode
  }
}

const UserService = {
  /**
     * Login the user and store the access token to TokenService.
     *
     * @returns access_token
     * @throws AuthenticationError
    **/
  login: async function (username, password) {
    // const requestData = {
    //   method: 'post',
    //   url: 'https://q2qceq1kl0.execute-api.us-east-1.amazonaws.com/dev/GalaxyOAUTH2',
    //   data: {
    //     // grant_type: 'password',
    //     username: '',
    //     password: ''
    //   }
    //   // auth: {
    //   //   username: process.env.VUE_APP_CLIENT_ID,
    //   //   password: process.env.VUE_APP_CLIENT_SECRET
    //   // }
    // }
    try {
      const response = await ApiService.post(process.env.VUE_APP_OAUTH_ENDPOINT, {
        username,
        password
      })

      TokenService.saveToken(response.data.AccessToken)
      TokenService.saveRefreshToken(response.data.RefreshToken)
      TokenService.saveIdToken(response.data.IdToken)
      ApiService.setHeader()

      // let redirect = response.role.includes(Roles.Admin) ? '/admin' : '/'
      // vm.$router.push({ path: redirect })
      // window.location.href = redirect
      // NOTE: We haven't covered this yet in our ApiService
      //       but don't worry about this just yet - I'll come back to it later
      // ApiService.mount401Interceptor()
      // callback(response)
      // return response.access_token
    } catch (error) {
      console.log('we got an error')
      console.log(error)
      // throw new AuthenticationError(error.response.status, error.response.data.detail)
    }
  },

  saveCurrentUserInfo: async function (idToken, route_list) {
    try {
      let currentUserDetails = {
        requestor_id: null,
        contact_id: null,
        groups: [],
        username: null,
        email: '',
        name: '',
        family_name: '',
        given_name: '',
        phone: '',
        view: 'user',
        viewcustomFields: false,
        routes: route_list
      }

      let parsedTokenData = parseToken(idToken)
      if (route_list[0].viewCustomFields >= 1) {
        currentUserDetails.viewcustomFields = true
      }

      if (parsedTokenData.email) {
        currentUserDetails.groups = parsedTokenData['cognito:groups']
        currentUserDetails.username = parsedTokenData['cognito:username']
        currentUserDetails.email = parsedTokenData['email']
        currentUserDetails.name = parsedTokenData['name']
        currentUserDetails.given_name = parsedTokenData['given_name']
        currentUserDetails.family_name = parsedTokenData['family_name']
        currentUserDetails.view = route_list[0].view

        let requestorGetParams = {
          params: {
            action: 'check-contact-requestor-info',
            Requestor_Email: parsedTokenData.email,
            Requestor_First_Name: parsedTokenData.given_name,
            Requestor_Last_Name: parsedTokenData.family_name,
            Contact_Email: parsedTokenData.email,
            Contact_First_Name: parsedTokenData.given_name,
            Contact_Last_Name: parsedTokenData.family_name
          }
        }
        let apiResponse = await ApiService.get(process.env.VUE_APP_OPPREG_API, requestorGetParams)
        currentUserDetails.requestor_id = apiResponse.data.Requestor_Id
        currentUserDetails.contact_id = apiResponse.data.Contact_Id
        if ('Contact_Phone' in  apiResponse.data) {
          currentUserDetails.phone = apiResponse.data.Contact_Phone
        }
        TokenService.saveCurrentUser(currentUserDetails)
      }
    } catch (error) {
      console.log('error: ' + error)
    }
  },

  refreshToken: async function () {
    const refreshTokenData = TokenService.getRefreshToken()
    const currentUser = JSON.parse(localStorage.getItem('currentUser'))
    if (!currentUser) return this.logout()
    const requestBody = {
      username: currentUser['username'],
      refresh_token: refreshTokenData
    }
    try {
      const response = await ApiService.post(process.env.VUE_APP_REFRESH_TOKEN_ENDPOINT, requestBody)
      console.log('new access token')
      console.log(response.data.AuthenticationResult.AccessToken)
      TokenService.saveToken(response.data.AuthenticationResult.AccessToken)
      ApiService.setHeader()
      return true
    } catch (error) {
      console.log('Unable to refresh Token: ' + error)
      throw new AuthenticationError(error.response.status, error.response.data.detail)
    }
  },

  validateToken: async function () {
    // try {
      let reqTokenBody = {token: TokenService.getToken()}
      const response = await ApiService.post(process.env.VUE_APP_VERIFY_TOKEN_ENDPOINT, reqTokenBody)
      
      if (response.data.hasOwnProperty('error')) {
        console.log('Token validation error: ' + response.data.error)
        return this.logout()
      } else {
        return response.data && response.data.result
      }
    // } catch (error) {
    //   console.log('Failed to validate Token: ' + error)
    //   return this.logout()
    // }
  },

  SSOLogin () {
    let sso_url = process.env.VUE_APP_AZURE_AD_LOGIN_URL + '=' + window.location.origin
    window.location.replace(sso_url);
  },

  authorize: async function (code) {
    store.commit('setLoader', { loading: true, text: 'Initializing' }, { root: true })
    let authParams = {
      action: 'authorization_code',
      code: code,
      redirect: window.location.origin
    }
    
    const response = await ApiService.post(process.env.VUE_APP_AUTHORIZE_CODE_ENDPOINT, authParams)
    
    if (!response.data.hasOwnProperty('access_token')) {
      window.location.href = process.env.VUE_APP_AZURE_AD_LOGOUT_URL + '=' + window.location.origin
      return
    }

    console.log('authorising')
    console.log(response)
    
    TokenService.saveToken(response.data.access_token)
    TokenService.saveRefreshToken(response.data.refresh_token)
    ApiService.setHeader()
    
    // let accessToken = parseToken(response.data.access_token)
    // if (accessToken.exp) {
    //   window.refreshTokenRequest = setInterval(() => {
    //     let current_time, isTokenExpiring
    //     current_time = Math.floor(new Date().getTime() / 1000.0)
    //     isTokenExpiring = (accessToken.exp - current_time) <= 60
    //     console.log("is token expiring? " + isTokenExpiring)
    //     if (isTokenExpiring) {
    //       this.refreshToken()
    //     }
    //   }, 60000)
    // }

    let groups = getUserGroup()
    let api_param = { group: groups.join(',') }
    let requestorGetResponse = await ApiService.post(process.env.VUE_APP_USERPOOL_GROUP, api_param)
    
    let route_list = requestorGetResponse.data
    await this.saveCurrentUserInfo(response.data.id_token, route_list)

    let currentUser = TokenService.getCurrentUser()
    
    vm.$store.commit('setUserLoggedIn', currentUser)
    
    vm.$store.commit('setFieldPermission', !(route_list[0].accessLevel >= 1))
    if (currentUser.view === 'admin') {
      vm.$store.dispatch('admin/init')
    } else {
      vm.$store.dispatch('user/init')
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
    
    vm.$router.push({ path: '/' })
  },

  switchView: function (code) {
    let currentUser = TokenService.getCurrentUser()
    currentUser.view = currentUser.view === 'admin' ? 'user' : 'admin'
    TokenService.saveCurrentUser(currentUser)
    vm.$store.commit('app/setSelectedFilter', 99, { root: true })
    vm.$store.commit('switchUserView', currentUser.view)
    vm.$router.push({ path: '/' })
  },

  /**
     * Logout the current user by removing the token from storage.
     *
     * Will also remove `Authorization Bearer <token>` header from future requests.
    **/
  logout () {
    console.log('logging out')
    TokenService.purge()
    ApiService.removeHeader()
    // TO DO: use global sign-out if check token validation is not enough. 
    window.location.href = process.env.VUE_APP_AZURE_AD_LOGOUT_URL + '=' + window.location.origin
    // window.location.href = '/' 
    // NOTE: Again, we'll cover the 401 Interceptor a bit later.
    ApiService.unmount401Interceptor()
  }

}

export default UserService

export { UserService, AuthenticationError }
